import { Input } from "@/src/components/universalInput";
import { UploadSpots } from "@/src/components/uploadSpots";
import { Patient, Exam, Reference } from "@/src/data/allTypes";
import { getUserId, getItemId } from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { ReferenceFieldsForm } from "../fields/referenceFieldsForm";

export function PatientExamForm({
  patient,
  reference,
  current,
  onChange,
}: {
  patient: Patient;
  reference: Reference;
  current?: Exam;
  onChange: (newValue: Exam) => void;
}) {
  let [data, setData] = useState(current || ({} as Exam));
  function setNewValue(newValue: Exam) {
    setData(newValue);
    onChange(newValue);
  }

  console.log("data", { data, reference });

  return (
    <div className="grid c1 gap15">
      {/* <div>
          <Input
            name="Notes"
            value={data.notes}
            type="textarea"
            placeholder="Texte libre..."
            rows={7}
            onChange={(newValue) => {
              setNewValue({ ...data, notes: newValue });
            }}
          />
        </div> */}

      {current?.parent != null && (
        <Input
          name="Date de l'examen"
          value={moment(data._date).format("YYYY-MM-DD HH:mm:ss")}
          type="datetime"
          onChange={(newValue) => {
            setNewValue({ ...data, _date: newValue });
          }}
        ></Input>
      )}

      <ReferenceFieldsForm
        patient={patient}
        currentAnswers={data.content?.fieldAnswers || []}
        reference={reference}
        onChange={(newValue) => {
          setNewValue({
            ...data,
            content: {
              ...(data.content || {}),
              creator: getUserId(),
              patient: getItemId(patient),
              fieldAnswers: newValue,
            },
          });
        }}
      ></ReferenceFieldsForm>

      <div>
        <Input
          name="Conclusion"
          value={data.conclusion}
          shouldFocus={reference.sections?.length == 0}
          type="textarea"
          placeholder="Texte libre..."
          rows={7}
          onChange={(newValue) => {
            setNewValue({ ...data, conclusion: newValue });
          }}
        />
      </div>

      <div className="field ">
        <div className="label">Fichiers</div>
        <UploadSpots
          spotsCount={3}
          value={data.uploads}
          additionalUploadData={{
            patient: getItemId(patient),
          }}
          onChange={(newValue) => {
            setNewValue({
              ...data,
              uploads: newValue,
            });
          }}
        />
      </div>
    </div>
  );
}
